import {captureException, captureMessage} from '@sentry/react';
import useAnalytics from 'utils/hooks/useAnalytics';

export const formStartAnalyticEvent = (
    isFirst = false,
    getLeadFormDataAnalyticEvent: ReturnType<typeof useAnalytics>['getLeadFormDataAnalyticEvent'],
) => {
    let duration = 0;

    try {
        const getLeadFormDataTime = performance.measure(
            'getLeadFormDataEnd',
            isFirst ? 'initGetLeadFormDataStart' : 'getLeadFormDataStart',
        );

        if (getLeadFormDataTime && getLeadFormDataTime.duration) {
            duration = getLeadFormDataTime.duration;
        } else {
            let message = 'Failed get performance.measure';

            try {
                const measures = performance.getEntriesByName('getLeadFormDataEnd', 'measure');
                if (measures.length) {
                    duration = measures[0].duration;
                    message += '; ok get by getEntriesByName';
                } else {
                    message += '; measures is empty';
                }
            } catch (e) {
                message += '; failed get by getEntriesByName';
            }
            captureMessage(message, 'debug');
        }
    } catch (e) {
        captureException(e);
    }

    if (duration) {
        getLeadFormDataAnalyticEvent(duration, isFirst);
    }
};
